import { createContext, useContext } from "react";
import { DESIGN_CALENDAR_CLIENTES_DEFAULT } from "./designCalendarClientes";

export const DesignCalendarClientesContext = createContext(
  DESIGN_CALENDAR_CLIENTES_DEFAULT,
);

export function useDesignCalendarClientes() {
  return useContext(DesignCalendarClientesContext);
}
